import { PatientDiscussion } from '../components/PatientDiscussion/PatientDiscussion';
import { PatientProfile } from '../components/PatientProfile/PatientProfile';
import { PatientsSection } from '../components/PatientsSection/PatientsSection';
import styles from './Container.module.scss';
import { NoContent, Spinner } from 'components';
import { selectCurrentPatientCase, selectCurrentPatientCaseIsLoading } from 'store/patients/selectors';
import { useSelector } from 'store/utils';

export const Container = () => {
  const isCaseLoading = useSelector(selectCurrentPatientCaseIsLoading);
  const currentPatientCase = useSelector(selectCurrentPatientCase);

  const content = currentPatientCase ? (
    <>
      <PatientProfile />
      <PatientDiscussion />
    </>
  ) : (
    <NoContent pageKey="patientProfile" className={styles.noContent} hideIcon />
  );

  return (
    <div className={styles.container}>
      <div className={styles.patientsSection}>
        <PatientsSection />
      </div>
      {isCaseLoading ? (
        <div className={styles.spinnerContainer}>
          <Spinner align="center" isLoading />
        </div>
      ) : (
        <div className={styles.patientInfo}>{content}</div>
      )}
    </div>
  );
};
